// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import cid from './cid';

require('./assets/sass/main.scss');

Vue.config.productionTip = false;

// require('./src/assets/sass/main.scss');
Vue.use(cid);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js